export default "__VITE_ASSET__DagVmuZQ__"